import * as React from "react";
import { Input as InputPrimitive } from "@base-ui/react/input";

import { cn } from "@/lib/utils";

type InputProps = React.ComponentProps<"input"> & { "data-slot"?: string };

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => {
  props["data-slot"] = props["data-slot"] ?? "input";
  const isInputGroupControl = props["data-slot"] === "input-group-control";
  return (
    <InputPrimitive
      ref={ref}
      className={cn(
        "min-w-0 bg-transparent text-foreground text-base file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm indent-px h-9 font-sans",
        isInputGroupControl
          ? "flex flex-1 shadow-none h-10 rounded-none border-0 px-3 py-2 ring-offset-background focus-visible:ring-0"
          : "dark:bg-input/30 border-input focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 disabled:bg-transparent dark:disabled:bg-input/80 rounded-lg border px-2.5 py-1 transition-colors file:h-6 focus-visible:ring-3 aria-invalid:ring-3 w-full file:inline-flex file:border-0 disabled:pointer-events-none",
        className
      )}
      {...props}
    />
  );
});

Input.displayName = "Input";

export { Input };
